export default __webpack_public_path__ + "static/media/UBL Bank Cheque.387dec6c.jpg";